import React from "react";

const AppContext = {};

export default AppContext;